<script setup lang="ts">
import { computed } from 'vue'
import { NTag, NText } from 'naive-ui'
import type { ConfigField } from '../../api'

const props = defineProps<{ field: ConfigField }>()

const displayValue = computed(() => {
  const v = props.field.value as any
  if (props.field.secret) {
    return v && v.has_value ? '已设置 ✓' : '未设置'
  }
  if (v === null || v === undefined || v === '') return '（空）'
  if (typeof v === 'boolean') return v ? 'true' : 'false'
  return String(v)
})
</script>

<template>
  <div class="cf-row">
    <div class="cf-head">
      <NText strong>{{ field.label }}</NText>
      <NTag size="small" :type="field.secret ? 'warning' : 'default'">
        {{ displayValue }}
      </NTag>
    </div>
    <div class="cf-meta">
      <div><b>来源</b>: <code>{{ field.source }}</code> · <b>修改方式</b>: {{ field.editable ? 'UI 可改' : '重启容器' }}</div>
      <div v-if="field.used_by.length"><b>用途</b>: {{ field.used_by.join(', ') }}</div>
      <div v-if="field.doc" class="cf-doc"><b>含义</b>: {{ field.doc }}</div>
    </div>
    <slot name="editor" />
  </div>
</template>

<style scoped>
.cf-row { padding: 10px 0; border-bottom: 1px dashed #eee }
.cf-row:last-child { border-bottom: none }
.cf-head { display: flex; gap: 12px; align-items: center }
.cf-meta { font-size: 12px; color: #555; margin-top: 4px; line-height: 1.6 }
.cf-meta code { background: #f3f4f6; padding: 0 4px; border-radius: 3px }
.cf-doc { white-space: pre-line }
</style>
